module.exports = new __parcel__URL__("github.bd6c5c96.svg").toString();